import { FooterHelp, Icon, InlineStack, Layout, Link } from '@shopify/polaris';
import React, { useEffect, useState } from 'react';
import { DI, DIProps } from '../../../../../Core';
import TemplateInformation from './TemplateInformation';
import ValueMappingComponent from './ValueMappingComponent';
import { CircleInformationMajor } from '@shopify/polaris-icons';
import { useTranslation } from 'react-i18next';
interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}

const ValueMapping = (props: Props): JSX.Element => {
    const { t } = useTranslation();
    return <>
        {/* <Banner tone='info'>Map attributes values for better product visibility on Amazon. Select values matching to corresponding Amazon attribute values.</Banner> */}
        <Layout>
            <TemplateInformation {...props} />
            <ValueMappingComponent {...props} />
        </Layout>
        <FooterHelp>
            <InlineStack gap="100" blockAlign="center">
                <div>
                    <Icon
                        source={CircleInformationMajor}
                        tone="info"
                    />
                </div>
                <div>{t("Learn more about")} </div>
                <Link target='_blank' url="https://support.cedcommerce.com/portal/en/kb/articles/templates-28-3-2025">
                    {t("CedCommerce Amazon Channel")},
                </Link><Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf'>
                    {t("Terms & Conditions")}
                </Link>{t("and")}<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf'>
                    {t("Data Privacy Rights.")}
                </Link> {t("Need Help?")}<Link onClick={() => props.history('support')}>
                    {t("Get Support")}
                </Link>
                <div> {t("or")} </div>
                <Link target='_blank' url="https://calendly.com/cedcommerce-awe-sales/sales" >
                    {t("Book a Call")}
                </Link>
            </InlineStack>
        </FooterHelp>
    </>;
}

export default DI(ValueMapping);